import type { CSSProperties } from 'react';
import logoPng from '@assets/logo-1_1767800057394.png';
import logoWebp from '@assets/logo-1_1767800057394.webp';
import logoAvif from '@assets/logo-1_1767800057394.avif';

const INTRINSIC_WIDTH = 568;
const INTRINSIC_HEIGHT = 174;

interface BrandLogoProps {
  height: number;
  /** Set on above-the-fold header logo for LCP prioritization. */
  priority?: boolean;
  style?: CSSProperties;
}

export function BrandLogo({ height, priority = false, style }: BrandLogoProps) {
  const width = Math.round((height * INTRINSIC_WIDTH) / INTRINSIC_HEIGHT);

  return (
    <picture>
      <source srcSet={logoAvif} type="image/avif" />
      <source srcSet={logoWebp} type="image/webp" />
      <img
        src={logoPng}
        alt="AI Fluens"
        width={width}
        height={height}
        decoding={priority ? 'sync' : 'async'}
        fetchPriority={priority ? 'high' : 'auto'}
        style={{
          height,
          width: 'auto',
          display: 'block',
          verticalAlign: 'top',
          ...style,
        }}
      />
    </picture>
  );
}
